import {Dropdown, Form, Icon, Input, Message, Popup} from "semantic-ui-react";
import {IDataTag} from "./FillDataModal";
import { useTranslation } from "react-i18next";
interface Props {
  tag: any;
  tagValues: any;
  counterOptions: any;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDropDownChange: (e: any, data: any) => void;
  ddValue: any;
  maxCounter: string;
}
export const FillDataInputField = ({tag, tagValues, counterOptions, onInputChange, onDropDownChange, ddValue, maxCounter}: Props) => {
  const {value = "", error = "", warning = ""} = tagValues?.find((tagValue: IDataTag) => tagValue.tag === tag.id) || {};
  const {t} = useTranslation();
  return (
    <>
        <Form.Field key={tag.id} name={tag.id} error={error !== undefined && error !== null && error !== ""}>
      <label>
        <Popup
          size="mini"
          trigger={
            <span>
              {tag.name} <Icon name="question circle outline" style={{paddingLeft: 2}} />
            </span>
          }
          content={(tag.usecounter === 1 && ddValue !== undefined && ddValue !== "" && ddValue !== null) || (tag.isprimary === 0 && tag.isgs1ai === 1) ? `${tag.id} ${t("read_only")}` : tag.id}
          position="right center"
          style={{padding: "5px 7px"}}
        />
      </label>
      <div style={{display: "flex", alignItems: "flex-start", width: "100%"}}>
        {tag.usecounter === 1 && (
          <Dropdown selection clearable placeholder={t("counter").toUpperCase()} name={tag.id} value={ddValue} options={counterOptions} onChange={onDropDownChange} style={{marginRight: 5, minWidth: "10em"}} />
        )}
        <Form.Input
          fluid
          width={16}
          error={error !== undefined && error !== null && error !== "" ? {content: error} : false}
          input={
            <Input
              placeholder={tag.defaulttext === "" ? tag.id : tag.defaulttext}
              value={tag.usecounter === 1 && ddValue !== undefined && ddValue !== "" && ddValue !== null ? maxCounter : value}
              name={tag.id}
              onChange={onInputChange}
              readOnly={(tag.usecounter === 1 && ddValue !== undefined && ddValue !== "" && ddValue !== null) || (tag.isprimary === 0 && tag.isgs1ai === 1)}
            />
          }
        />
      </div>
      {warning !== undefined && warning !== "" && (
      <Message color="yellow" compact style={{padding: "7px 10px", width: "100%", fontWeight: "bold"}} size="tiny" content={warning} />
    )}
    </Form.Field>
    </>
  );
};
